export type GenericValueLabelType = {
    value: string;
    label: string;
};

export enum Gender {
    MALE = 'male',
    FEMALE = 'female',
    INTERSEX = 'intersex',
    NONBINARY = 'non_binary',
    NOTPROVIDED = 'not_provided',
    OTHER = 'non_listed',
    TRANSGENDER = 'transgender',
}

export enum Languages {
    ARABIC = 'Arabic',
    BENGALI = 'Bengali',
    CANTONESE = 'Cantonese',
    FRENCH = 'French',
    GERMAN = 'German',
    GUJARATI = 'Gujarati',
    ITALIAN = 'Italian',
    LITHUANIAN = 'Lithuanian',
    MANDARIN = 'Mandarin',
    OTHER_CHINESE = 'Other Chinese',
    POLISH = 'Polish',
    PORTUGUESE = 'Portuguese',
    PUNJABI = 'Punjabi',
    SOMALI = 'Somali',
    SPANISH = 'Spanish',
    TAMIL = 'Tamil',
    TURKISH = 'Turkish',
    URDU = 'Urdu',
    WELSH = 'Welsh',
}

export enum Admission {
    ADMITTED = 'Admitted',
    DISCHARGED = 'Discharged',
}
